import React, { useCallback, useEffect, useState } from 'react';
import { Container, Grid, IconButton, Typography } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit,  faPaperPlane, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';

import TableHeader from '../common/TableHeader';
import { ModalAction } from '../common/Modal';
import { Title } from './style';
import { Noresults } from '../../Layout/style';
import { deleteCommunicationById, getCommunicated } from '../../actions/Communicated';
import { CommonButton } from '../common/Buttons';
import { Text } from '../common/NotificationTable/style';

const AdminCommunicated = ({ history }) => {
  const dispatch = useDispatch();
  const { communicated } = useSelector(({ communicated }) => ({
    communicated: communicated?.communicated || [],
  }));

  const [modal, setModal] = useState({
    open: false,
    type: null,
    title: null,
    action: null,
  });
  const [searchString, setSearchString] = useState('');
  const [filteredElements, setFilteredElements] = useState('');

  useEffect(() => {
    dispatch(getCommunicated());
  }, []);

  useEffect(() => {
    if (searchString?.length > 0) {
      setFilteredElements(
        communicated.filter((i) => {
          return i.title.toUpperCase().match(searchString.toUpperCase());
        }),
      );
    } else setFilteredElements(communicated);
  }, [communicated, searchString]);

  const closeAndUpdate = useCallback(() => {
    setFilteredElements([])
    dispatch(getCommunicated());

    setModal({ open: false, type: null, title: null, action: null });
  });

  const columns = [
    {
      field: 'title',
      flex: 2,
      headerName: 'Título',
      renderCell: ({ row }) => <Text>{row.title}</Text>,
    },
    {
      field: 'date',
      flex: 1,
      headerName: 'Data',
      renderCell: ({ row }) => <Text>{row.createdAt}</Text>,
    },
    // {
    //   field: 'channel',
    //   flex: 1,
    //   headerName: 'Canal',
    //   renderCell: ({ row }) => <Text>{row.channel}</Text>,
    // },
    {
      field: 'public',
      flex: 1,
      headerName: 'Público',
      renderCell: ({ row }) => <Text>{row.publico}</Text>,
    },
    {
      field: 'actions',
      headerName: 'Açoes',
      flex: 1,
      sortable: false,
      renderCell: ({ row }) => (
        <>
          <IconButton
            onClick={() => {
              history.push(`/admin/gestao_de_Comunicados/comunicado/${row.id}`);
            }}
          >
            <FontAwesomeIcon icon={faPaperPlane} />
          </IconButton>
          <IconButton
            onClick={() => {
              history.push(`/admin/gestao_de_Comunicados/comunicado/${row.id}/1`);
            }}
          >
            <FontAwesomeIcon icon={faEdit} />
          </IconButton>
          <IconButton
            onClick={() =>
              setModal({
                open: true,
                type: 'del',
                title: 'Deletar Comunicado',
                action: () => {
                  dispatch(deleteCommunicationById(row.id)).then(() => closeAndUpdate());
                },
              })
            }
          >
            <FontAwesomeIcon icon={faTimes} />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <>
      <Container>
        <Title variant="h2">Gestão de Comunicados</Title>
        <TableHeader
          setSearchString={setSearchString}
          placeholder="Pesquisar por Nome"
          btnAction={() => history.push('/admin/gestao_de_Comunicados/comunicado')}
        />
        <div style={{ height: 500, width: '100%', background: 'white' }}>
          <DataGrid
           components={{
            NoRowsOverlay: () => (
              <Noresults>
                <span>
                  Resultados não encontrado
                </span>
              </Noresults>
            ),
          }}
            pageSize={10}
            disableSelectionOnClick
            disableColumnMenu
            hideFooterSelectedRowCount
            rows={filteredElements.length ? filteredElements : []}
            columns={columns}
          />
        </div>
        <Grid container justify={'space-between'} style={{ marginTop: 15 }}>
          <Grid item xs={2}>
            <CommonButton action={() => history.push('/admin/gestao_de_Comunicados/modelos')} label="Gerenciar Modelos" />
          </Grid>
        </Grid>
      </Container>
      <ModalAction
        title={modal.title || 'Modal'}
        successAction={modal.action}
        open={modal.open}
        successActive={true}
        successLabel={'Deletar'}
        backAction={() => {
          setModal({ open: false, type: null });
        }}
      >
        <Typography>Tem certeza que deseja cancelar o Comunicado?</Typography>
      </ModalAction>
    </>
  );
};

export default AdminCommunicated;
